import CryptoJS from 'crypto-js'

const KEY = CryptoJS.enc.Utf8.parse('1592653589793238')
const IV = CryptoJS.enc.Utf8.parse('2718281828459045')

export function Encrypt(str) {
    const srcs = CryptoJS.enc.Utf8.parse(str)
    // const okey = CryptoJS.enc.Utf8.stringify(KEY)
    const encrypted = CryptoJS.AES.encrypt(srcs, KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding,
    })
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

export function Decrypt(str) {
    const base64 = CryptoJS.enc.Base64.parse(str)
    const src = CryptoJS.enc.Base64.stringify(base64)
    const decrypt = CryptoJS.AES.decrypt(src, KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding,
    })
    const decrypedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decrypedStr.toString()
}
